export default __webpack_public_path__ + "3d546b2c6ca80130f9e059860694b0e2.png";